import {api, ApiResponse, setAuthToken} from "./api";
import {Utilisateur} from "./apiUtilisateurs";

export interface LoginPayload {
	email: string;
	password: string;
}

export interface RegisterPayload {
	nom: string;
	prenom: string;
	telephone?: string;
	email: string;
	password: string;
	password_confirmation: string;
	groupe: number;
}

export interface ResetPasswordPayload {
	email: string;
	token: string;
	password: string;
	password_confirmation: string;
}

/**
 * LOGIN — reçoit : { token, user }
 */
export const login = async (payload: LoginPayload) => {
	const response = await api.post('/jwt/login', payload);

	const token = response.data.access_token;
	const expiresIn = response.data.expires_in; // en secondes

	setAuthToken(token, expiresIn);

	return response.data;
};

/**
 * REGISTER — rien à changer
 */
export const register = async (payload: RegisterPayload) => {
	const response = await api.post('/jwt/register', payload);

	const token = response.data.access_token;
	const expiresIn = response.data.expires_in; // en secondes

	setAuthToken(token, expiresIn);

	return response;
};

/**
 * LOGOUT — supprime le token en local
 * (Le backend peut optionnellement invalider le token)
 */
export const logout = async () => {
	try {
		await api.post('/jwt/logout'); // si tu veux gérer les blacklists côté back
	} catch (e) {
		// aucune importance, on logout côté front
	}

	setAuthToken(null);
};

/**
 * CHECK AUTH — utilise une route protégée JWT
 * Remplace /auth/check qui utilisait la session Sanctum
 */
export const checkAuth = async (): Promise<ApiResponse<Utilisateur>> => {
	try {
		const response = await api.get<ApiResponse<Utilisateur>>('/jwt/me');
		return response.data;
	} catch (error) {
		console.error('Erreur lors de la vérification de l\'utilisateur', error);
		throw error;
	}
};

export const forgotPassword = async (email: string) => {
	return api.post('/forgot-password', {email});
};

export const resetPassword = async (data: ResetPasswordPayload) => {
	return api.post('/reset-password', data);
};

export const debug = async () => {
  return api.post('/api/debug-cookies');
};

export const debugSanctum = async () => {
  return api.post('/api/v1/debug-cookies-sanctum');
};

